import React from 'react';

const SkeletonBanners_b = () => {
    return (
        <div className="skeleton-banners_b-wrapper xmt-20">
            <div className="container">
                <div className="banner_b br-4 xpx-10 skeleton-loading d-flex align-items-center justify-content-between">
                    <div className="text-banner br-4 skeleton-loading"></div>
                    <div className="button-banner br-6 skeleton-loading"></div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonBanners_b;
